// src/modules/app-views/invoices/pages/Init/components/tableColumns/orderNumberColumn.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Tooltip, Typography } from 'antd';
import translateX from 'utils/translateX';

const { Text } = Typography;

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************

// Renders an order number array column with +N badge for multiple values.
// options.dataIndex: field to read (default: 'orderNumber', goodsReceipt uses 'purchaseOrderNumber')
function orderNumberColumn(buildColumnProps, options = {}) {
  const {
    dataIndex = 'orderLegacyCode',
    searchPlaceholder = 'order_number',
    search = true,
  } = options;

  return {
    title: translateX('order'),
    dataIndex,
    ...buildColumnProps(dataIndex, { sort: true, search, searchPlaceholder }),
    width: 100,
    align: 'center',
    render: (_, record) => {
      const raw = record?.[dataIndex];
      const rawLegacy = dataIndex === 'orderLegacyCode' ? record?.orderNumber : null;
      const ordersArray = Array.isArray(raw)
        ? raw
        : raw
          ? [raw]
          : Array.isArray(rawLegacy)
            ? rawLegacy
            : rawLegacy
              ? [rawLegacy]
              : [];

      if (ordersArray.length === 0) return <Text type="secondary">—</Text>;

      const firstOrder = ordersArray[0];
      const extraCount = ordersArray.length - 1;
      const tooltipContent = ordersArray.length > 1 ? ordersArray.join(', ') : null;

      const content = (
        <div className="invoices-list-card__order-cell">
          <Text>{firstOrder}</Text>
          {extraCount > 0 && (
            <span className="invoices-list-card__order-badge">+{extraCount}</span>
          )}
        </div>
      );

      return tooltipContent ? <Tooltip title={tooltipContent}>{content}</Tooltip> : content;
    },
  };
}

export default orderNumberColumn;
